import { Box, GKCheckbox, Typography } from "components";
import { Controller, useFormContext } from "react-hook-form";

interface Props {
  terms: string;
  disabled?: boolean;
}

const TermsAndConditions = ({ terms, disabled }: Props) => {
  const form = useFormContext();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
      <Typography color="var(--black-900)" fontSize={14} fontWeight={700}>
        Terms &amp; Conditions
      </Typography>

      <Box
        sx={{
          bgcolor: "var(--white)",
          border: "1px solid #E3E8EF",
          borderRadius: "12px",
          color: "var(--neutral-500)",
          fontSize: 13,
          lineHeight: 1.6,
          maxHeight: "220px",
          overflowY: "auto",
          p: "16px 20px",
          whiteSpace: "pre-wrap",
        }}
      >
        {terms || "No terms provided."}
      </Box>

      <Controller
        name="consentAccepted"
        control={form.control}
        render={({ field }) => (
          <Box
            component="label"
            sx={{
              alignItems: "flex-start",
              cursor: disabled ? "default" : "pointer",
              display: "flex",
              gap: "4px",
            }}
          >
            <GKCheckbox
              checked={!!field.value}
              onChange={(event) => field.onChange(event.target.checked)}
              disabled={disabled}
              disableLeftPadding
            />
            <Typography
              color="var(--black-900)"
              fontSize={13}
              fontWeight={500}
              mt="9px"
            >
              I have read and agree to the terms &amp; conditions, and authorise
              this order to be placed on my behalf.
            </Typography>
          </Box>
        )}
      />
    </Box>
  );
};

export default TermsAndConditions;
